import React,{useEffect, useState} from 'react'
import config, { getHeaders } from "../config";
import { reactLocalStorage } from 'reactjs-localstorage';
import "./Leaderboard.scss"
import queryString from "query-string";
import { useLocation } from 'react-router-dom';
import Loader from './Loader';
function Leaderboard() {
   const [leaderboardList,setLeaderboardList]=useState([])
   const [yourScore,setYourScore]=useState([])
   const [showData,setShowData]=useState(false)
   const [loading,setLoading]=useState(false)
   const [message,setMessage]=useState("")
   let { search } = useLocation();
   const { date } = queryString.parse(search);
   console.log("date is::",date)
      useEffect(()=>
      {
        const msisdn =reactLocalStorage.get("msisdn")
        const uid =  reactLocalStorage.get("uid"); 
        const url = `${config.get("base")}${config.get("leaderboard")}`;
        setLoading(true)
        fetch(url, {
          method: "POST",
          // body: JSON.stringify({ uid: uid }),
          body:JSON.stringify({date:date}),
          headers: getHeaders(),
        })
          .then((res) => {
            if (!res.ok) {
              throw res;
            }
            return res.json();
          })
          .then(
            (result) => {
              if(result.status.toLowerCase()=='success')
              {
                setShowData(true)
                setLoading(false)
                setLeaderboardList(result.data?.userScore)
                setYourScore(result.data?.yourScore)
                console.log("result message::", result);
              }
              else if(result.status.toLowerCase()=="failed")
              {
               
                setShowData(false)
                setLoading(false)
                setMessage(result.message)
              }
              else{
                setShowData(false)
                setLoading(false)
                setMessage(result.message)
              }
              
            },
            (error) => {
              console.log("error:::", error);
            }
          );
       
      
      },[date])
    
    
   console.log(yourScore)
  //  const displayNumber=(num)=>
  //  {
  //     return "********"+num.slice(8,12)
  //  }
   
    return (
    <div className="container m-w display align-ld">
        <div className="columns is-mobile">
            <div className="column is-full">
        {/* <img src={leaderboard} alt="leaderbaord" className='ld-img'/> */}
        <div className="title is-6 mb-0 capatalize text-white text-left mt-2 border-left">      
            <span className='mr-2 mt-2'>Leaderboard</span>
            </div>
           {!loading && showData &&
        <div className='leaderboard text-md'>
        <div className='leaderboard-header '>
            <div className='w-3 text-center'>
               RANK NO.
            </div>
            <div className='w-3 text-center'>
                PHONE NO.
            </div>
            <div className='w-3 text-center'>
               POINTS
            </div>
        </div>
        
        {yourScore && 
         yourScore &&
         <div className='score yourscore'>
            <div className='w-3'>
               {yourScore.rank}
            </div>
            <div className='w-3'>
            {yourScore.number}
            </div>
            <div className='w-3'>
            {yourScore.points}
            </div>
            </div>
        }
        {leaderboardList &&
        leaderboardList.map((item,i)=>
         {
            
            return <div className='score' key={item.rank}>
                <div className='w-3'>
               {item.rank}
            </div>
            <div className='w-3'>
            {item.number}
            {/* {displayNumber(item.number)} */}
            </div>
            <div className='w-3 text-center'>
            {item.points}
            </div>
                </div>
         })}

        </div>
          }
          {
            loading && !showData &&
            <Loader/>
          }
          {
            !showData && !loading &&
            // <div className='error-text'>No data found</div>
            <div className='msg-text'>
            <div className='error-text'>{message?message:"No data found"}</div>
            </div>
          }
         
    </div>
    </div>
    </div>
  )
}

export default Leaderboard